module.exports = __webpack_public_path__ + "img/contact.1123156c.png";